import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";
import {
  ServicesAssignResourceColumnsLoadModel
} from "../../../deliveries/models/services-assign-resource-columns.model";

export class RouteTotalsComponent implements IController {

  columns: ServicesAssignResourceColumnsLoadModel;
  weight: number;
  dimensions: any;
  volume?: any;
  numberOfPackages: number
  numberOfSpots: number;
  numberOfPallets: number;
  extraWeight: number;
  extraDimensions: any;
  extraNumberOfPackages: number;
  extraNumberOfSpots: number;
  extraNumberOfPallets: number;
  subVolumeList: boolean;
  isRow?: boolean;


  public weightUnit: any;
  public volumeUnit: any;
  public labelsMap: any;

  constructor(private splitService: SplitService) {
    this.weightUnit = splitService.getWeightUnit();
    this.volumeUnit = splitService.getVolumeUnit();

    this.labelsMap = {};
    const siteLabels = this.splitService.getSiteLabels();
    _.forEach(siteLabels, (l) => {
      this.labelsMap[l.name] = l;
    })
  }

}

angular
  .module('bringoz.admin.routes')
  .component('routeTotals', {
    bindings: {
      columns: '<?',
      weight: '<?',
      extraWeight: '<?',
      dimensions: '<?',
      volume: '<?',
      extraDimensions: '<?',
      numberOfPackages: '<?',
      extraNumberOfPackages: '<?',
      numberOfSpots: '<?',
      extraNumberOfSpots: '<?',
      numberOfPallets: '<?',
      extraNumberOfPallets: '<?',
      subVolumeList: '<?',
      isRow: '<?'
    },
    template: require('./route-totals.html').default,
    controller: RouteTotalsComponent
  });
